import type { light_offer_extended } from "@/lib/models/light_offer_extended";

const dummyOffers: light_offer_extended[] = [
  {
    id: 1,
    ref: "DUMMY001",
    title: "サンプルクーポン1",
    subtitle: "特別割引",
    discount_value: 100,
    discount_type: 0,
    picture_url: "/images/dummy-offer-1.svg",
    user_quota: 1,
    best: true,
    is_new: false,
    points: 50,
    is_holder_required: false,
    default_target: false,
    precedence: 0,
    unavailable_clip_image_url: "",
    unavailable_clip_text: "",
    bl_message_ref: undefined,
  },
  {
    id: 2,
    ref: "DUMMY002",
    title: "サンプルクーポン2",
    subtitle: "お得な割引",
    discount_value: 200,
    discount_type: 0,
    picture_url: "/images/dummy-offer-2.svg",
    user_quota: 1,
    best: false,
    is_new: true,
    points: 100,
    is_holder_required: false,
    default_target: false,
    precedence: 0,
    unavailable_clip_image_url: "",
    unavailable_clip_text: "",
    bl_message_ref: undefined,
  },
];

export default dummyOffers;
